export const GlobalStorage = window.o_global?.Storage;
